import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { hrmsGetRequest } from "../services";

const initialState = {
  adminStaff: [],
  loading: false,
  error: null,
};

export const fetchAdminStaff = createAsyncThunk(
  "administrators/fetchAdminStaff",
  async (_, { rejectWithValue }) => {
    try {
      const response = await hrmsGetRequest("/api/administrators");
      if (response.status !== 200) {
        return rejectWithValue("Failed to fetch admin staff");
      }
      return response.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const administratorSlice = createSlice({
  name: "administrators",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchAdminStaff.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAdminStaff.fulfilled, (state, action) => {
        state.loading = false;
        state.adminStaff = action.payload;
      })
      .addCase(fetchAdminStaff.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default administratorSlice.reducer;
